import React from 'react';
import './cosmos.css';

// Gargantua : trou noir stylisé (disque d'accrétion incliné en rotation + anneau
// de lentille + horizon), avec une station en orbite basse.
// Purement décoratif, motion douce, désactivée en prefers-reduced-motion.
const Gargantua = () => (
  <div className="gargantua" aria-hidden="true">
    <span className="halo"></span>
    <span className="disk disk-a"></span>
    <span className="disk disk-b"></span>
    <span className="lens"></span>
    <span className="core"></span>

    <span className="orbit">
      <svg className="ship" viewBox="0 0 40 40">
        <circle cx="20" cy="20" r="13" fill="none" stroke="#e8ecf5" strokeWidth="1.2" opacity="0.85" />
        <circle cx="20" cy="20" r="13" fill="none" stroke="#f5a524" strokeWidth="1.4" strokeDasharray="2 3.2" />
        <circle cx="20" cy="7" r="1.6" fill="#8fe3f0" />
      </svg>
    </span>
  </div>
);

export default Gargantua;
